
















































import PartnerFooter from "@/components/partner/PartnerFooter.vue";
import TheNavigationBase from "@/layouts/TheNavigationBase.vue";
import { AssetEnum, AssetRepository } from "@/lib/AssetRepository";
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";
import { ReportModule } from "@/store/modules/report.store";
import { UiModule } from "@/store/modules/ui.store";
import { Component, Prop, Vue } from "vue-property-decorator";
import ProfileMenu from "@/components/profile/ProfileMenu.vue";
import { UserModule } from "@/store/modules/user.store";
import { ConfigModule } from "@/store/modules/config";
import { NotificationModule } from "@/store/modules/notification.store";
import eventBus from "@/lib/eventBus";

@Component({
  components: {
    TheNavigationBase,
    PartnerFooter,
    ProfileMenu
  }
})
export default class TheLayoutBase extends Vue {
  private defaultLogoUrl = AssetRepository.getAsset(false, AssetEnum.logo);

  @Prop({ default: "white" })
  private backgroundColor!: string;

  @Prop({ default: false })
  private showLoginButton!: boolean;

  @Prop({ default: "grey darken-3" })
  private backgroundDarkColor!: string;

  @Prop({ default: 0 })
  private progress!: number;

  @Prop({ default: true })
  private showFooter!: boolean;

  @Prop({ default: false })
  private displayDivider!: boolean;

  @Prop({})
  private headerLogo?: string;

  @Prop({ default: false })
  isEndUser!: boolean;

  get color() {
    return getDefaultPartnerColor();
  }

  get navigationSettings() {
    return ConfigModule.navigationSettings;
  }

  get partner() {
    return ReportModule.partner;
  }

  set drawer(val: any) {
    UiModule.setDrawer(val);
  }

  get drawer() {
    return UiModule.drawer;
  }

  get notificationCount() {
    return NotificationModule.notifications.length;
  }

  get isHeadless() {
    return ConfigModule.headless;
  }

  toggleDrawer() {
    UiModule.setDrawer(!UiModule.drawer);
  }

  goToLogin() {
    this.$router.push({ path: "/login" });
  }

  /**
   * Try to set the Header Logo by priority
   *
   */
  get tryHeaderLogo() {
    if (this.headerLogo) {
      return this.headerLogo;
    }

    if (this.partner.settings?.reportSettings?.logoUrl) {
      return this.partner.settings?.reportSettings?.logoUrl;
    }

    if (this.partner.settings?.logoUrl) {
      return this.partner.settings?.logoUrl;
    }

    return this.defaultLogoUrl;
  }

  get isAuthenticated() {
    return UserModule.isAuthenticated;
  }

  get isNotification() {
    return NotificationModule.isNotification;
  }

  notificationButtonClicked(event: any) {
    eventBus.$emit("notificationButtonClicked", event);
    this.$router.push({ name: "ThgOverview" });
  }

  items = [
    {
      text: "Login",
      disabled: false,
      href: "#/login"
    },
    {
      text: "Impressum",
      disabled: false,
      href: "#/impressum"
    },
    {
      text: "Datenschutz",
      disabled: false,
      href: "#/datenschutz"
    },
    {
      text: "AGB",
      disabled: false,
      href: "#/agbs"
    }
  ];
}
